import React from 'react';

const NotFound = () => {
    return (
        <div className='text-center mt-5'>
            <h2 className='text-danger'>404 !! Not Found</h2>
            <img src="https://images.unsplash.com/photo-1650692201357-3b1b15469952?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NTd8fDQwNCUyMG5vdCUyMGZvdW5kfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60" alt="" />
        </div>
    );
};

export default NotFound;